import React from "react";
import * as Constants from "../../consts/Constants.js";
import Style from "../../styles/js/StyleDashboard.js";
import MovementChart from "./MovementChart.js";
import MapVisit from "./MapVisit.js";
import SelectDates from "../../components/common/SelectDates";
import Paper from "@material-ui/core/Paper";
import { formatDateDDMMYYYYT0000 } from "../../utils/DateUtils";
import Axios from "axios";

const getDefaultFinalDate = () => {
  return formatDateDDMMYYYYT0000(new Date().getTime());
};

const getDefaultInitialDate = () => {
  let now = new Date();
  let newDate = new Date(now.setDate(now.getDate() - 14));
  return formatDateDDMMYYYYT0000(newDate.getTime());
};

export default function Dashboard() {
  const style = Style();
  const [state, setState] = React.useState({
    initialDate: getDefaultInitialDate(),
    finalDate: getDefaultFinalDate(),
    dataMovementChart: [],
    dataVisitsChart: [],
  });

  const getData = (startDateParam, endDateParam) => {
    let dataMovementChart = [];
    let dataVisitsChart = [];
    Axios.all([
      Axios.get(
        Constants.FINAL_URL_VISITS_BETWEEN_DATES +
          "/" +
          startDateParam +
          "/" +
          endDateParam
      ),
      Axios.get(
        Constants.FINAL_URL_BETWEEN_DATES +
          "/" +
          startDateParam +
          "/" +
          endDateParam
      ),
    ])
      .then(
        Axios.spread((responseVisits, responseMap) => {
          if (responseVisits.status === Constants.RESPONSE_OK) {
            dataVisitsChart = responseVisits.data;
          }
          if (responseMap.status === Constants.RESPONSE_OK) {
            dataMovementChart = responseMap.data;
          }
        })
      )
      .catch((error) => {})
      .finally(() => {
        setState({
          ...state,
          dataMovementChart: dataMovementChart,
          dataVisitsChart: dataVisitsChart,
        });
      });
  };

  const submit = () => {
    let startDateParam = new Date(state.initialDate).getTime().toString();
    let endDateParam = new Date(state.finalDate).getTime().toString();
    getData(startDateParam, endDateParam);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  return (
    <div className={style.dashboard}>
      <Paper className={style.rowDashboard}>
        <SelectDates
          initialDate={state.initialDate}
          finalDate={state.finalDate}
          submit={submit}
          handleChange={handleChange}
        />
      </Paper>
      <Paper className={style.rowDashboard}>
        <MovementChart
          data={state.dataMovementChart}
          startDate={state.initialDate}
          endDate={state.finalDate}
        />
        <MapVisit data={state.dataVisitsChart} />
      </Paper>
    </div>
  );
}
